"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var SubmitButton = function (_a) {
    var type = _a.type, amount = _a.amount, currency = _a.currency, loading = _a.loading, currencySettings = _a.currencySettings;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var balanceData = (0, swr_hooks_1.useBalance)().data;
    var isSubmitButtonDisabled = (0, react_1.useMemo)(function () {
        var _a;
        if (currencySettings &&
            balanceData &&
            type === 'cashout' &&
            Number((balanceData === null || balanceData === void 0 ? void 0 : balanceData.amount) || 0) < Number(currencySettings.min))
            return true;
        //@ts-ignore
        var errorsCount = (_a = Object.keys(formState === null || formState === void 0 ? void 0 : formState.errors)) === null || _a === void 0 ? void 0 : _a.length;
        if (!formState.touched || errorsCount > 0)
            return true;
    }, [type, currencySettings, balanceData, formState.errors, formState.touched]);
    return (react_1.default.createElement("div", { style: { marginTop: '20px' } },
        react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", color: "primary", text: "upper", loading: loading, height: "44px", maxWidth: "100%", disabled: isSubmitButtonDisabled }, t("".concat(type)))));
};
exports.default = SubmitButton;
